import React from "react";
import {useTranslation} from "react-i18next";
import styled from "styled-components";

const StyledRoot = styled.div`
    background: #E1E7E9 0% 0% no-repeat padding-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    & div {
        padding: 2rem 5rem 5rem 5rem;
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 6px #00000029;
    }
    & p {
        font-size: 42px;
        letter-spacing: 0;
        color: #0D5B83;
    }
    & span {
         font-size: 24px;
         letter-spacing: 0;
         color: #0D5B83;
    }
`;

function View() {
   const {t} = useTranslation();
   return (<StyledRoot>
      <div>
         <p>404</p>
         <span>{t('error_404')}</span>
      </div>
   </StyledRoot>);
}

export default View